export default function Play({ ...props }) {
  return (
    <svg viewBox="0 0 16.503 19.502" {...props}>
      <path
        d="M15.778 8.466 2.278.225A1.453 1.453 0 0 0 .769.197 1.481 1.481 0 0 0 0 1.497v16.5a1.481 1.481 0 0 0 .769 1.3 1.453 1.453 0 0 0 1.509-.028l13.5-8.241a1.5 1.5 0 0 0 0-2.569Z"
        fill="#fff"
      />
    </svg>
  );
}
